/**
 * AI Wall Preview Configuration
 *
 * Scene:
 *   背景 + 挂画中心点
 *
 * Product:
 *   比例 + 尺寸
 *
 * Frame:
 *   框类型
 */


window.AI_WALL_CONFIG = {


    // ==================================
    // 场景配置
    // ==================================

    scenes:{


        living:{


            name:"Living Room",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/wall-living.jpg?v=1783934534",


            // 挂画中心点
            anchor:{
                x:58,
                y:35
            }


        },



        bedroom:{


            name:"Bedroom",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/wall-bedroom.jpg?v=1783934534",


            anchor:{
                x:50,
                y:28
            }


        },



        gallery:{


            name:"Gallery Wall",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/wall-gallery.jpg?v=1783934534",


            anchor:{
                x:50,
                y:28
            }


        },



        minimal:{


            name:"Minimal Home",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/wall-minimal.jpg?v=1783934534",


            anchor:{
                x:50,
                y:28
            }


        },



        office:{


            name:"Office",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/wall-office.jpg?v=1783934534",


            anchor:{
                x:50,
                y:28
            }


        }



    },







    // ==================================
    // 产品比例 + 尺寸
    // ==================================


    products:{


        // 正方形
        square:{


            ratio:"1:1",



            sizes:{


                "10x10":{


                    scale:10

                },



                "20x20":{


                    scale:20

                },
                "32x32":{


                    scale:30


                }



            }


        },





        // 竖版
        portrait:{


            ratio:"4:5",


            sizes:{


                "12x16":{


                    scale:30


                },



                "16x20":{


                    scale:30


                }


            }



        },






        // 横版
        landscape:{


            ratio:"3:2",


            sizes:{


                "18x12":{


                    scale:30


                },



                "24x16":{


                    scale:30


                }


            }


        }



    },








    // ==================================
    // 框配置
    // 暂时只定义结构
    // ==================================


    frames:{


        white:{

            name:"White Frame",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-white.png",

            scale:1.3

        },


        black:{

            name:"Black Frame",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-black.png",

            scale:1.3

        },


        wood:{

            name:"Espresso Frame",

            image:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-espresso.png",

            scale:1.3

        }



    }



};